import FetchLoadingIndicator from "../../../components/fetch-status-components/loading.component";
import FetchErrorIndicator from "../../../components/fetch-status-components/error.component.view";

export const useApiViewStatus = (
	status,
	loadingComponent = FetchLoadingIndicator,
	errorComponent = FetchErrorIndicator
) => {
	function componentType() {
		switch (status) {
			case "error":
				return errorComponent;
			case "loading":
				return loadingComponent;
			default:
				return loadingComponent;
		}
	}

	return {
		apiIndicatorShow: status === "error" || status === "loading",
		apiIndicatorComponent: componentType(),
	};
};
